import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/router';
import { Providers } from '@/app/providers';
import { getWsClient } from '@/lib/ws/ws-client';
import '@/styles/globals.css';

async function bootstrap() {
  // Mark dev so the cursor stays visible for mouse-based development.
  if (import.meta.env.DEV) document.body.setAttribute('data-dev', 'true');

  if (__USE_MOCKS__ && import.meta.env.VITE_USE_MOCKS !== 'false') {
    const { startMockWorker } = await import('@/mocks/browser');
    await startMockWorker();
  }

  // Establish WS connection (drives connectivity-store.wsConnected).
  getWsClient().connect();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
}

void bootstrap();
